var _a, _b;
import { __spreadArray } from "tslib";
import ddt from '@wix/da-ddt';
import { handleActions } from 'redux-actions';
import { pushModal, replaceModal, popModal, removeModal, removeModalsOfType, } from './actionCreators';
import { reduxKey } from './constants';
var handler = handleActions((_a = {},
    _a[pushModal.toString()] = function (state, action) {
        if (!action.payload) {
            ddt.warn('modals', 'Modal push without payload');
            return state;
        }
        return __spreadArray(__spreadArray([], state), [action.payload]);
    },
    _a[replaceModal.toString()] = function (state, action) {
        if (!action.payload) {
            ddt.warn('modals', 'Modal replace without payload');
            return state;
        }
        return __spreadArray(__spreadArray([], state.slice(0, -1)), [action.payload]);
    },
    _a[popModal.toString()] = function (state, action) {
        return state.slice(0, -1);
    },
    _a[removeModalsOfType.toString()] = function (state, action) {
        return state.filter(function (item) { return item.type !== action.payload; });
    },
    _a[removeModal.toString()] = function (state, action) {
        return state.filter(function (item) { return item.id !== action.payload; });
    },
    _a), []);
export default (_b = {},
    _b[reduxKey] = handler,
    _b);
//# sourceMappingURL=reducer.js.map